<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div *ngIf="!$hasMissingRequiredInParams"
          class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="update" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_edit_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
              <ng-template 
                toolbarToolDef="attachments" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_attachments_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized && !$hasMissingRequiredInParams">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden && !filtersets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-inventory_type" *ngIf="!filters.inventory_type.hidden && !filters.inventory_type.removed" 
                                  class="field-container double {{filters.inventory_type.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.inventory_type.styles.style"
                                  [ngClass]="filters.inventory_type.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.inventory_type.label + (filters.inventory_type.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.inventory_type.label}}<span *ngIf="filters.inventory_type.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <FootPrintPortalManager-inventory_aggregation_dd_single 
                                  data-cy="selector"
                                  [type]="filters.inventory_type.control.type"
                                  formControlName="inventory_type"
                                  (displayTextChange)="filters.inventory_type.control.displayText=$event"
                                  [placeholder]="filters.inventory_type.control.placeholder"
                                  [styles]="filters.inventory_type.control.styles"
                                  [tooltip]="filters.inventory_type.control.tooltip"
                              >
                              </FootPrintPortalManager-inventory_aggregation_dd_single>
                              <ng-container *ngIf="filters.inventory_type.invalid">
                                <ng-container *ngFor="let error of filters.inventory_type.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.total_available_amount_widget.hidden && !widgets.total_available_amount_widget.removed" class="widget-container">
            <Inventory-total_available_amount_widget
            #$widgets_total_available_amount_widget 
              [materialId]="$widgets_total_available_amount_widget_inParams_materialId"
            ($refreshEvent)="refresh(false, false, '$widgets_total_available_amount_widget')"
            >
            </Inventory-total_available_amount_widget>
          </div>
          <div *ngIf="!widgets.total_available_base_amount_widget.hidden && !widgets.total_available_base_amount_widget.removed" class="widget-container">
            <Inventory-total_available_base_amount_widget
            #$widgets_total_available_base_amount_widget 
              [materialId]="$widgets_total_available_base_amount_widget_inParams_materialId"
            ($refreshEvent)="refresh(false, false, '$widgets_total_available_base_amount_widget')"
            >
            </Inventory-total_available_base_amount_widget>
          </div>
          <div *ngIf="!widgets.total_gross_weight_widget.hidden && !widgets.total_gross_weight_widget.removed" class="widget-container">
            <Inventory-total_gross_weight_widget
            #$widgets_total_gross_weight_widget 
              [materialId]="$widgets_total_gross_weight_widget_inParams_materialId"
            ($refreshEvent)="refresh(false, false, '$widgets_total_gross_weight_widget')"
            >
            </Inventory-total_gross_weight_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.inventory.hasTabToShow" class="tab" data-cy="tab-inventory">
              <h2 [className]="tabs.inventory.active? 'active': ''" (click)="tabs.inventory.activate()">{{tabs.inventory.title}}</h2>
            </div>
            <div *ngIf="tabs.tasks.hasTabToShow" class="tab" data-cy="tab-tasks">
              <h2 [className]="tabs.tasks.active? 'active': ''" (click)="tabs.tasks.activate()">{{tabs.tasks.title}}</h2>
            </div>
            <div *ngIf="tabs.packagings.hasTabToShow" class="tab" data-cy="tab-packagings">
              <h2 [className]="tabs.packagings.active? 'active': ''" (click)="tabs.packagings.activate()">{{tabs.packagings.title}}</h2>
            </div>
          </div>
        
              <ng-container
                *ngIf="tabs.inventory.active">
                  <mat-select (selectionChange)="onTabSelected($event)"
                              *ngIf="subTabGroups.inventory.tabs.length > 1"
                              class="datex-queryselector"
                              [value]="subTabGroups.inventory.activeTab"
                              disableOptionCentering
                              panelClass="dropdown-below datex-dropdownpanel">
                    <mat-option [value]="tab" *ngFor="let tab of subTabGroups.inventory.tabs">{{tab.title}}</mat-option>
                  </mat-select>
                
                  <FootPrintPortalManager-inventory_pallet_grid
                   *ngIf="tabs.inventory.tabs.inventory_by_lp.active"
                  #$tabs_inventory_inventory_by_lp
                  [materialIds]="$tabs_inventory_inventory_by_lp_inventory_pallet_grid_inParams_materialIds"
                  ($refreshEvent)="refresh(false, false, '$tabs_inventory_inventory_by_lp')">
                  </FootPrintPortalManager-inventory_pallet_grid>
                  <FootPrintPortalManager-inventory_lot_grid
                   *ngIf="tabs.inventory.tabs.inventory_by_lot.active"
                  #$tabs_inventory_inventory_by_lot
                  [materialIds]="$tabs_inventory_inventory_by_lot_inventory_lot_grid_inParams_materialIds"
                  ($refreshEvent)="refresh(false, false, '$tabs_inventory_inventory_by_lot')">
                  </FootPrintPortalManager-inventory_lot_grid>
                  <FootPrintPortalManager-inventory_material_grid
                   *ngIf="tabs.inventory.tabs.inventory_by_material.active"
                  #$tabs_inventory_inventory_by_material
                  [materialIds]="$tabs_inventory_inventory_by_material_inventory_material_grid_inParams_materialIds"
                  ($refreshEvent)="refresh(false, false, '$tabs_inventory_inventory_by_material')">
                  </FootPrintPortalManager-inventory_material_grid>
              </ng-container>
              <FootPrintPortalManager-inventory_tasks_grid *ngIf="tabs.tasks.active"
              #$tabs_tasks
              [materialIds]="$tabs_tasks_inventory_tasks_grid_inParams_materialIds"
              ($refreshEvent)="refresh(false, false, '$tabs_tasks')">
              </FootPrintPortalManager-inventory_tasks_grid>
              <FootPrintPortalManager-material_packagings_grid *ngIf="tabs.packagings.active"
              #$tabs_packagings
              [materialId]="$tabs_packagings_material_packagings_grid_inParams_materialId"
              ($refreshEvent)="refresh(false, false, '$tabs_packagings')">
              </FootPrintPortalManager-material_packagings_grid>
        </div>

      </ng-container>
      <div *ngIf="$hasMissingRequiredInParams"
           class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
    </div>
  </div>
</div>